import { render, staticRenderFns } from "./riskStatisticsDetail.vue?vue&type=template&id=a57fea34&scoped=true"
import script from "./riskStatisticsDetail.vue?vue&type=script&lang=js"
export * from "./riskStatisticsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57fea34",
  null
  
)

export default component.exports